import { ITrainingCentreListItem } from 'partner360/components/trainingCentre/components/trainingCentrePopup/components/trainingCentreContent/models'
import { ITrainingRtm } from 'partner360/models/trainingCentre/ITrainingCentre'

import { ReactComponent as CatalogIcon } from '../../../../../assets/catalog.svg'

export const getRtmListItems = (
  rtms: ITrainingRtm[],
  onSelectRtm: (rtm: string) => void
): ITrainingCentreListItem[] => {
  return [...rtms]
    .sort((a, b) => a.Order - b.Order)
    .map((rtm) => {
      return {
        id: rtm.Rtm,
        icon: CatalogIcon,
        title: `${rtm.Rtm}`,
        onClick: () => onSelectRtm(rtm.Rtm),
      }
    })
}
